export default "/_next/static/images/prefill-essentials-37ff8020dbb0f590207429b9dfaf429b.png";